import * as React from 'react'
import { Datagrid, DateField, Filter, List, SearchInput } from 'react-admin'
import { FC } from 'react'

import { IdentitiesField } from './identities_field'
// import { QuickFilter } from 'dash/shared';
import { User } from 'shared/types'
import { UserBlock } from 'shared/molecules/UserBlock'

const UserFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    {/* <QuickFilter source="roles" label="Admins" defaultValue={['admin']} /> */}
  </Filter>
)

export const UserList = () => (
  <List exporter={false} filters={<UserFilter />} perPage={25}>
    <Datagrid rowClick="edit">
      <UserBlock showRoles label="User" />
      <IdentitiesField source="identities" />
      <DateField source="lastSignInAt" label="Last Login" />
      <DateField source="createdAt" label="Registered" />
    </Datagrid>
  </List>
)
